import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { browserList, detectBrowser } from 'utils/BrowserDetection';

export const CustomTooltip = withStyles(() => ({
  tooltip: {
    marginTop: '0px !important',
    backgroundColor: '#f5f5f5 !important',
    opacity: '1 !important',
    textAlign: 'left',
    fontSize: '13px',
    letterSpacing: '-0.26px',
    color: '#3c3c3c',
    wordBreak: 'break-word',
    borderRadius: '12px',
    boxShadow:
      '2px -1px 8px 0 rgba(0, 0, 0, 0.15), -1px 2px 8px 0 rgba(0, 0, 0, 0.15)',
    width: '300px !important',
    fontWeight: '300',
  },
}))(Tooltip);

export const SmallCustomTooltip = withStyles(() => ({
  tooltip: {
    marginTop: '0px !important',
    backgroundColor: '#f5f5f5 !important',
    opacity: '1 !important',
    textAlign: 'left',
    fontSize: '13px',
    letterSpacing: '-0.26px',
    color: '#3c3c3c',
    wordBreak: 'break-word',
    borderRadius: '12px',
    boxShadow:
      '2px -1px 8px 0 rgba(0, 0, 0, 0.15), -1px 2px 8px 0 rgba(0, 0, 0, 0.15)',

    fontWeight: '300',
  },
}))(Tooltip);

export const RevisionTextCustomTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#f5f5f5 !important',
    opacity: '1 !important',
    textAlign: 'left',
    fontSize: '13px',
    letterSpacing: '-0.26px',
    color: '#3c3c3c',
    wordBreak: 'break-word',
    borderRadius: '12px',
    boxShadow:
      '2px -1px 8px 0 rgba(0, 0, 0, 0.15), -1px 2px 8px 0 rgba(0, 0, 0, 0.15)',
    fontWeight: '300',
  },
}))(Tooltip);

export const CustomWhiteTooltip = withStyles(() => ({
  tooltip: {
    verticalAlign: 'middle',
    border: 'solid 1px transparent',
    borderRadius: '30px',
    backgroundColor: 'white',
    color: '#3c3c3c',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Poppins', sans-serif !important",
  },
}))(Tooltip);

export const CustomTooltipSmall = withStyles(() => ({
  tooltip: {
    marginTop: '0px !important',
  },
}))(Tooltip);


export const CustomTooltipStatus = withStyles(() => ({
  tooltip: {
    verticalAlign: 'middle',
    border: 'solid 1px transparent',
    borderRadius: '30px',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Poppins', sans-serif !important",
  },
}))(Tooltip);


export const CustomTooltipDanger = withStyles(() => ({
  tooltip: {
    verticalAlign: 'middle',
    border: 'solid 1px transparent',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Poppins', sans-serif !important",
  },
}))(Tooltip);